import React from "../_snowpack/pkg/react.js";
import App from "../components/app.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {withAttrs} from "../common/utils.js";
import {Title} from "../components/typo.js";
import {t} from "../common/i18n.js";
import {fontFamily, media} from "../components/theme.js";
import Logo from "../components/logo.js";
import Stack from "../components/stack.js";
export default function Maintenance(props) {
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(LogoReduced, null), /* @__PURE__ */ React.createElement(Headline, null, t("Wartungsarbeiten")), /* @__PURE__ */ React.createElement(Text, null, t("Wegen Wartungsarbeiten ist Printmate.de Shop nicht verfügbar.")), /* @__PURE__ */ React.createElement(Text, null, t("Wir bitten um Ihr Verständnis."))));
}
const Header = styled(withAttrs(Stack, {spacing: "l"}))`
  align-items: center;
  margin-top: 100px;

  ${media.phone} {
    --spacing: 24px;
  }
`;
const Headline = styled(withAttrs(Title, {level: 1}))`
  font-size: 24px;
`;
const Text = styled.div`
  font-family: ${fontFamily.primary};
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  text-align: center;

  a {
    color: inherit;
  }

  ${media.phone} {
    font-size: 14px;
  }
`;
const LogoReduced = styled(Logo)`
  margin-bottom: 61px;
  z-index: 3;
  display: flex;
  justify-content: center;
`;
